import {
  Children,
  cloneElement,
  forwardRef,
  memo,
  ReactElement,
  Ref,
} from 'react';
import {
  Group,
  InputAddon,
  InputElementProps,
  InputGroupProps,
} from '@chakra-ui/react';

import { InputElement } from './InputElement';

const InputGroupComponent = (
  props: InputGroupProps,
  ref: Ref<HTMLDivElement>,
) => {
  const {
    startElement,
    startElementProps,
    endElement,
    endElementProps,
    startAddon,
    startAddonProps,
    endAddon,
    endAddonProps,
    children,
    startOffset = '0px',
    endOffset = '0px',
    ...rest
  } = props;

  const child = Children.only<ReactElement<InputElementProps>>(children);
  const attached = Boolean(startAddon || endAddon);

  return (
    <Group
      ref={ref}
      attached={attached}
      skip={(el) => el.type === InputElement}
      width="full"
      {...rest}
    >
      {startAddon && <InputAddon {...startAddonProps}>{startAddon}</InputAddon>}
      {startElement && (
        <InputElement pointerEvents="none" {...startElementProps}>
          {startElement}
        </InputElement>
      )}
      {cloneElement(child, {
        ...(startElement && {
          ps: `calc(var(--input-height) - ${startOffset})`,
        }),
        ...(endElement && { pe: `calc(var(--input-height) - ${endOffset})` }),
        ...children.props,
      })}
      {endElement && (
        <InputElement placement="end" {...endElementProps}>
          {endElement}
        </InputElement>
      )}
      {endAddon && <InputAddon {...endAddonProps}>{endAddon}</InputAddon>}
    </Group>
  );
};

export const InputGroup = memo(
  forwardRef<HTMLDivElement, InputGroupProps>(InputGroupComponent),
);
